export default "/_next/static/chunks/bust-lo-draco.2a6e13219808ecd6fbf98078ebb86ea8.glb";